import { baseURL } from "./apiUrl";

export const imageBasePath = `${baseURL}/images`;
